import React, { useState, useEffect, useContext } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import { MyContext } from './context/UserProvider';
import { useNavigate } from 'react-router-dom';
import { SlArrowLeftCircle, SlArrowRightCircle } from "react-icons/sl";

export default function CategoriasProdutos() {
  const { produtos, setProdutos, produto1, setProduto1 } = useContext(MyContext);
  
  const navigate = useNavigate();

  // Estado para controlar a imagem atual
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Função que faz a requisição para obter os dados dos sofás
 const getInfoSofas = async () => {
  const toSearch = {}; // Aqui você pode adicionar filtros ou parâmetros para a busca, se necessário

  const apiBase = process.env.REACT_APP_API_URL;


  try {
    const response = await fetch(`${apiBase}/api/getInfoSofas`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toSearch),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const json = await response.json();
    setProdutos(json); // Armazena a resposta no estado
  } catch (error) {
    console.error('Erro na requisição:', error);
  }
};


  const openNewPage = () => {
    const selectedProduct = produtos[currentImageIndex];
    setProduto1(selectedProduct);
    navigate('/produto');
  };

  // Funções para navegar pelas imagens
  const nextImage = () => {
    if (produtos.length > 0) {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % produtos.length);
    }
  };

  const prevImage = () => {
    if (produtos.length > 0) {
      setCurrentImageIndex((prevIndex) => (prevIndex - 1 + produtos.length) % produtos.length);
    }
  };

  const selectImage = (index) => {
    setCurrentImageIndex(index);
  };

  // Hook para buscar as informações assim que o componente for montado
  useEffect(() => {
    getInfoSofas();
  }, []);

  // Tamanho fixo das imagens, sem redimensionamento baseado na tela
  const imgWidth = '100%';  // Largura fixa para as imagens
  const imgHeight = '600px'; // Altura fixa proporcional

  return (
    <div translate="no">
      <Navbar />

      {/* Seção de apresentação com navegação de imagem principal */}
      <div
        style={{
          textAlign: 'center'
        }}
      >
        <div
          style={{
            width: imgWidth,
            height: imgHeight,
            margin: '0 auto',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
            position: 'relative'
          }}
        >
          {produtos.length > 0 && (
            <div
              onClick={openNewPage}
              style={{
                backgroundImage: `url(${produtos[currentImageIndex].imagem_url})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                width: '100%',
                height: '100%',
                cursor: 'pointer'
              }}
            ></div>
          )}

          {/* Botões de navegação (setas) */}
          <button
            onClick={prevImage}
            style={{
              position: 'absolute',
              top: '50%',
              left: '10px',
              transform: 'translateY(-50%)',
              background: 'rgba(0, 0, 0, 0.0)',
              border: 'none',
              color: 'white',
              padding: '10px',
              fontSize: '20px',
              borderRadius: '50%',
              cursor: 'pointer'
            }}
          >
            <SlArrowLeftCircle
              style={{
                fontSize: '40px'
              }}
            />
          </button>
          <button
            onClick={nextImage}
            style={{
              position: 'absolute',
              top: '50%',
              right: '10px',
              transform: 'translateY(-50%)',
              background: 'rgba(0, 0, 0, 0.0)',
              border: 'none',
              color: 'white',
              padding: '10px',
              fontSize: '20px',
              borderRadius: '50%',
              cursor: 'pointer'
            }}
          >
            <SlArrowRightCircle
              style={{
                fontSize: '40px'
              }}
            />
          </button>

          {/* Botões circulares sobrepondo a imagem no canto inferior */}
          <div
            style={{
              position: 'absolute',
              bottom: '10px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            {produtos.length > 0 &&
              produtos.map((produto, index) => (
                <button
                  key={index}
                  onClick={() => selectImage(index)}
                  style={{
                    width: '20px',
                    height: '20px',
                    margin: '0 px',
                    borderRadius: '50%',
                    backgroundColor: currentImageIndex === index ? 'rgb(255, 187, 51)' : '#ccc',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s'
                  }}
                ></button>
              ))}
          </div>
        </div>
      </div>

      {/* Nova seção de lista de objetos consumidos */}
      <div
        style={{
          padding: '20px',
          justifyItems: 'center'
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: '20px',
            overflowX: 'auto'
          }}
        >
          {produtos.length > 0 &&
            produtos.map((produto) => (
              <div
                key={produto.produto_id}
                style={{
                  textAlign: 'center',
                  width: 'auto',
                  backgroundColor: 'rgba(128, 128, 128, 0.1)',
                  borderRadius: '10px',
                  padding: '10px'
                }}
              >
                <img
                  src={produto.imagem_url}
                  alt={produto.produto_nome}
                  style={{
                    width: '150px',
                    height: '100px',
                    objectFit: 'cover',
                    borderRadius: '10px'
                  }}
                />
                <p>{produto.categoria_nome}</p>
              </div>
            ))}
        </div>
      </div>

      {/* Seção de lista de produtos com descrição alternada */}
      <div
        style={{
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '20px'
        }}
      >
        {produtos.length > 0 &&
          produtos.map((produto, index) => {
            const isEven = index % 2 === 0;

            return (
              <div
                key={index}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '10px',
                  borderRadius: '10px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                  padding: '10px',
                  backgroundColor: '#fff'
                }}
              >
                {/* Imagem do produto */}
                <div
                  onClick={() => navigate('/produto', { state: { produto1: produto } })}
                  style={{
                    width: '50%',
                    height: '500px',
                    backgroundImage: `url(${produto.imagem_url})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    cursor: 'pointer',
                    borderRadius: '10px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                  }}
                ></div>

                {/* Descrição do produto */}
                <div
                  style={{
                    maxWidth: '400px',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <h3
                    style={{
                      fontSize: '18px'
                    }}
                  >
                    {produto.produto_nome}
                  </h3>
                  <p
                    style={{
                      fontSize: '14px',
                      color: '#666'
                    }}
                  >
                    {produto.produto_descricao}
                  </p>
                  <button
                    style={{
                      backgroundColor: '#ffbb33',
                      padding: '10px',
                      border: 'none',
                      color: 'white',
                      cursor: 'pointer',
                      borderRadius: '5px',
                      fontWeight: 'bold',
                      textAlign: 'center'
                    }}
                  >
                    Ver Produto
                  </button>
                </div>
              </div>
            );
          })}
      </div>

      <Footer />
    </div>
  );
}
